import { formatNumber } from '../numberFormat';

const money = (n, digits) =>
  n == null ? '—' : `${n < 0 ? '-' : ''}$${formatNumber(Math.abs(n), digits)}`;

export const $ = n => money(n, 0);

export const $2 = n => money(n, 2);

export const fH = n =>
  n == null ? '—' : formatNumber(n, 1);

// Fixed-decimals number in the active format (display replacement for toFixed)
export const fN = (n, digits = 0, minDigits = digits) =>
  n == null ? '—' : formatNumber(n, digits, minDigits);

export const pct = n =>
  n == null ? '—' : `${n >= 0 ? '+' : ''}${formatNumber(n, 1)}%`;

export const barColor = p =>
  p >= 80 ? 'var(--green)' : p >= 40 ? 'var(--amber)' : 'var(--red)';

export const profitCls = n => n >= 0 ? 'profit-pos' : 'profit-neg';

export const MONTH_NAMES = ['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const monthLabel = (yr, mo) => `${MONTH_NAMES[mo]} ${yr}`;

export const DEPT_COLORS = {
  'Creative':      { bg:'var(--dept-creative-bg)',   fg:'var(--dept-creative-fg)' },
  'Account Mgmt':  { bg:'var(--dept-acct-bg)',       fg:'var(--dept-acct-fg)' },
  'Production':    { bg:'var(--dept-production-bg)', fg:'var(--dept-production-fg)' },
  'Media':         { bg:'var(--dept-media-bg)',      fg:'var(--dept-media-fg)' },
  'Strategy & BI': { bg:'var(--dept-strategy-bg)',   fg:'var(--dept-strategy-fg)' },
  'Operations':    { bg:'var(--dept-ops-bg)',        fg:'var(--dept-ops-fg)' },
  'New Business':  { bg:'var(--dept-newbiz-bg)',     fg:'var(--dept-newbiz-fg)' },
  'Unassigned':    { bg:'var(--dept-unassigned-bg)', fg:'var(--dept-unassigned-fg)' },
};

export function DeptBadge({ dept, style = {} }) {
  const c = DEPT_COLORS[dept] || DEPT_COLORS['Unassigned'];
  return (
    <span style={{
      display:'inline-block', padding:'2px 8px', borderRadius:4,
      fontSize:10, fontWeight:600, letterSpacing:'0.3px',
      background:c.bg, color:c.fg, ...style,
    }}>{dept}</span>
  );
}

export function MarginChip({ value }) {
  if (value == null) return <span style={{ color:'var(--text3)', fontFamily:'DM Mono,monospace', fontSize:12 }}>—</span>;
  const pos = value >= 0;
  return (
    <span style={{
      display:'inline-block', padding:'2px 8px', borderRadius:4,
      fontSize:11, fontWeight:600, fontFamily:'DM Mono,monospace',
      background: pos ? 'var(--green-bg)' : 'var(--red-bg)',
      color: pos ? 'var(--green)' : 'var(--red)',
    }}>{pos ? '+' : ''}{fN(value, 1)}%</span>
  );
}

export function UtilBar({ pct: p, width = 70 }) {
  return (
    <div style={{ display:'flex', alignItems:'center', gap:6 }}>
      <div style={{ width, height:5, background:'var(--border)', borderRadius:3, overflow:'hidden', flexShrink:0 }}>
        <div style={{ width:`${Math.min(p,100)}%`, height:'100%', borderRadius:3, background:barColor(p) }} />
      </div>
      <span style={{ fontFamily:'DM Mono,monospace', fontSize:12 }}>{fN(p, 0)}%</span>
    </div>
  );
}
